module.exports = __webpack_public_path__ + "static/media/pic-sl1.689347ae.png";